import { environment } from 'environments/environment';
import { Deserializable } from '../deserializable.model';
import { HttpParams } from '@angular/common/http';


export class PageRequest implements Deserializable {
    currentPage: number = 1;
    itemsPerPage: number = environment.defaultItemsPerPage;
    query?: string;
    searchQuery?: string;
    assignedToUserId?: any;
    userID?: any;
    standardId?: any;
    parentId?: any;
    auditId?: any;
    auditNumber?: any;
    auditorEvalId?: any;
    queryRole?: string;
    queryStartDate?: any;
    queryEndDate?: any;
    status?: string;
    active?: number;
    auditStatus?: string[];
    deleted?: boolean;
    attachmentType?: string;
    documentType?: string;
    description?: string;
    requestStatus?: string;
    requestStatuses?: string[];
    rowNum?: any;
    showUnassignedOnly?: string;
    customer?: string;
    salesRep?: string;
    personId?: any;
    priorityClient?: any;
    documentID?: any;
    mmrID?: any;
    // selectedUser: UserProfile;
    tabStatus?: string;
    sort?: string;
    sortDir?: string;
    eventType?: string;
    slug?: string;
    search?: any;
    usage?: any;
    quoteStatusId?: number;
    roleList?: any;
    clientId: any;
    applicationId?: any;
    quoteID?: any;
    allData: any;
    isExport: any;
    searchParam: any;
    like: Object;
    hideColumns?: string;
    exportType:string;
    documentChangeId?: number;

    deserialize(input: any): this {
        return Object.assign(this, input);
    }

    toParams(): HttpParams {
        let params = new HttpParams()
            .set('itemsPerPage', this.itemsPerPage.toString())
            .set('currentPage', this.currentPage.toString());
        if (this.query) {
            params = params.set('query', this.query);
        }

        if (this.sort) {
            params = params.set('sort', this.sort);
        }

        if (this.sortDir) {
            params = params.set('sortDir', this.sortDir);
        }

        if (this.status) {
            params = params.set('status', this.status);
        }
        return params;
    }
}
